var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import debounce from "lodash/debounce";
import { useStableOkapiKy } from "./useStableOkapiKy";
import { fetchOnixCodetables, fetchOnixCodetableSummary, } from "../api/onixService";
export var useOnixCodetableItemsFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var ky = useStableOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState({
        value: "",
        description: "",
    }), filters = _a[0], setFilters = _a[1];
    var _b = useState(""), temporaryValueFilter = _b[0], setTemporaryValueFilter = _b[1];
    var _c = useState(""), temporaryDescriptionFilter = _c[0], setTemporaryDescriptionFilter = _c[1];
    var _d = useState(""), selectedOnix = _d[0], setSelectedOnix = _d[1];
    var _e = useState([]), onixOptions = _e[0], setOnixOptions = _e[1];
    var _f = useState(false), onixLoading = _f[0], setOnixLoading = _f[1];
    var _g = useState(null), selectedOnixOption = _g[0], setSelectedOnixOption = _g[1];
    var debouncedFetch = useMemo(function () {
        return debounce(function (name) { return __awaiter(void 0, void 0, void 0, function () {
            var trimmedName, res, items, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        trimmedName = name.trim();
                        if (!trimmedName) {
                            setOnixOptions([]);
                            return [2 /*return*/];
                        }
                        setOnixLoading(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, fetchOnixCodetables(ky, { name: trimmedName })];
                    case 2:
                        res = _c.sent();
                        items = (_b = res.items) !== null && _b !== void 0 ? _b : [];
                        setOnixOptions(items.map(function (item) { return ({ value: item.id, label: item.name }); }));
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _c.sent();
                        setOnixOptions([]);
                        return [3 /*break*/, 5];
                    case 4:
                        setOnixLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, 300);
    }, [ky]);
    useEffect(function () {
        return function () {
            debouncedFetch.cancel();
        };
    }, [debouncedFetch]);
    useEffect(function () {
        var params = new URLSearchParams(location.search);
        var value = params.get("value") || "";
        var description = params.get("description") || "";
        var tableId = params.get("onixCodetableId") || "";
        setFilters({ value: value, description: description });
        setTemporaryValueFilter(value);
        setTemporaryDescriptionFilter(description);
        setSelectedOnix(tableId);
    }, [location.search]);
    useEffect(function () {
        if (!selectedOnix) {
            setSelectedOnixOption(null);
            return;
        }
        var loadOption = function () { return __awaiter(void 0, void 0, void 0, function () {
            var table, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchOnixCodetableSummary(ky, selectedOnix)];
                    case 1:
                        table = _b.sent();
                        if (table) {
                            setSelectedOnixOption({
                                value: table.id,
                                label: table.name,
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        setSelectedOnixOption(null);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOnix]);
    var updateUrlWithFilters = useCallback(function (filters, tableId) {
        var params = new URLSearchParams();
        if (filters.value)
            params.set("value", filters.value);
        if (filters.description)
            params.set("description", filters.description);
        if (tableId)
            params.set("onixCodetableId", tableId);
        history.push({ search: params.toString() });
    }, [history]);
    var handleApplyFilters = function () {
        var next = {
            value: temporaryValueFilter,
            description: temporaryDescriptionFilter,
        };
        setFilters(next);
        updateUrlWithFilters(next, selectedOnix);
    };
    var handleClearFilters = function () {
        setTemporaryValueFilter("");
        setTemporaryDescriptionFilter("");
        setFilters({ value: "", description: "" });
        setSelectedOnix("");
        history.push({ search: "" });
    };
    var handleOnixInput = function (input) {
        debouncedFetch(input);
    };
    var handleOnixSelection = function (id) {
        setSelectedOnix(id);
        updateUrlWithFilters(filters, id);
    };
    var isAnyFilterActive = function () {
        return !!filters.value || !!filters.description || !!selectedOnix;
    };
    var onixDataOptions = useMemo(function () {
        var baseOptions = [
            {
                value: "",
                label: formatMessage({
                    id: "ui-br-agency.collectionsList.select.option.all",
                }),
            },
        ];
        if (selectedOnixOption &&
            !onixOptions.some(function (opt) { return opt.value === selectedOnixOption.value; })) {
            return __spreadArray(__spreadArray(__spreadArray([], baseOptions, true), [selectedOnixOption], false), onixOptions, true);
        }
        return __spreadArray(__spreadArray([], baseOptions, true), onixOptions, true);
    }, [onixOptions, selectedOnixOption, formatMessage]);
    return {
        filters: filters,
        selectedOnix: selectedOnix,
        temporaryValueFilter: temporaryValueFilter,
        temporaryDescriptionFilter: temporaryDescriptionFilter,
        setTemporaryValueFilter: setTemporaryValueFilter,
        setTemporaryDescriptionFilter: setTemporaryDescriptionFilter,
        onixOptions: onixOptions,
        onixDataOptions: onixDataOptions,
        onixLoading: onixLoading,
        selectedOnixOption: selectedOnixOption,
        handleOnixInput: handleOnixInput,
        handleOnixSelection: handleOnixSelection,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
    };
};
